/* @flow */
import MenuItem from 'components/MenuItem.jsx';
import ModalTrigger from 'components/ModalTrigger.jsx';
import React from 'react';

class ModalMenuItem extends React.Component {
  static propTypes = {
    modal: React.PropTypes.node.isRequired,
    disabled: React.PropTypes.bool,
  };

  static defaultProps = {
    disabled: false,
  };

  render() {
    let menuItem = <MenuItem {...this.props}>{this.props.children}</MenuItem>;

    if (!this.props.disabled) {
      menuItem = <ModalTrigger modal={this.props.modal}>{menuItem}</ModalTrigger>;
    }

    return menuItem;
  }
}

export default ModalMenuItem;



// WEBPACK FOOTER //
// ./src/components/ModalMenuItem.jsx